/**
 * Created by jbz on 2017/10/16.
 */
import Vuex from 'vuex';
import Vue from 'vue';

import AccountModule from './modules/account';
import GlobalVariableModule from './modules/global-variable';
import RootModule from './modules/root';
import LocationModule from './modules/location';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    AccountModule,
    GlobalVariableModule,
    RootModule,
    LocationModule
  }
});
